import { Activity, Result, Funnel, Host, SDX, UserAction, User } from './officeeventschema.tml';
import { Error } from './Office.System.Error';
var _Activity = Activity;
var _Result = Result;
var _Error = Error;
var _Funnel = Funnel;
var _Host = Host;
var _SDX = SDX;
var _UserAction = UserAction;
var _User = User;
export var Contracts;
(function (Contracts) {
    var Office;
    (function (Office) {
        var System;
        (function (System) {
            System.Activity = _Activity;
            System.Result = _Result;
            System.Error = _Error;
            System.Funnel = _Funnel;
            System.Host = _Host;
            System.SDX = _SDX;
            System.User = _User;
            System.UserAction = _UserAction;
        })(System = Office.System || (Office.System = {}));
    })(Office = Contracts.Office || (Contracts.Office = {}));
})(Contracts || (Contracts = {}));
//# sourceMappingURL=Contracts.js.map